export default {
  "ORDER_WAIT_SHIP": "発送待ち",
  "Men fashion": "男性ファッション",
  "MyAccount_MyProfile_label_First": "名",
  "MyAccount_MyShippingDetails_Phone": "電話番号",
  "Page_not_found_message1": "申し訳ありませんが、このページが見つかりません",
  "Help": "ヘルプ",
  "Sign in": "ログイン",
  "Register": "登録",
  "Category_sorting_Item": "並べ替え方法を選択",
  "cart_clear": "ショッピングカートを空にする",
  "Payment & Delivery": "支払いと配送",
  "Send my feedback": "フィードバックを送信",
  "MyAccount_MyProfile_Save": "変更を保存",
  "Continue_billing": "お支払いを続ける",
  "Categories": "カテゴリー",
  "Read and understand": "申し込みに同意する",
  "Feel free to edit": "詳細情報をいつでも編集し、アカウントを最新に保ちましょう",
  "Select payment method": "支払い方法を選択",
  "Login_input_email": "Eメール",
  "Login_input_first": "名",
  "Account": "アカウント",
  "Create_Time_Asc": "日付昇順",
  "concactus_label": "メッセージまたは問い合わせ",
  "Order_Grade": "注文評価",
  "wishlist_empty_desc": "ショッピングバッグに商品が追加されていません。ショッピングを開始しましょう！",
  "cartpreviewShipping_messageinfo": "配送確認および到着予定をメールでお送りいたします。",
  "unsubscribe": "退会することができます",
  "prompt": "プロンプト",
  "MyAccount_MyProfile_yinsi_message": "Brand name では、個人情報に関するプライバシー問題に非常に重視し、ユーザーの個人データを保護することに尽力しています。",
  "About us": "私たちについて",
  "or": "または",
  "MyAccount_Order_History_All": "全ての注文履歴",
  "What_We_Improve": "私たちはどう改善すべきか？",
  "MyAccount_ShippingDetails_title": "配送詳細",
  "MyAccount_Order_History_Tabs2": "未支払い",
  "Go_back_shopping": "ショッピングに戻る",
  "Product": "製品",
  "Order summary": "注文概要",
  "payment_order_total": "合計",
  "Download": "ダウンロードする",
  "Your_Purchase_Order": "あなたの注文",
  "Your_Account": "あなたのアカウント",
  "order_after_sales_list_null": "アフターセールス注文は現在ありません",
  "All_After_sales_orders": "全てのアフターセールス注文",
  "Filters": "フィルター",
  "search_results_not": "指定されたフレーズに一致する結果はありませんでした",
  "ORDER_WAIT_RECEIPT": "受取待ち",
  "ORDER_CLOSED": "閉じた注文",
  "Order_View_details": "詳細を見る",
  "Subscribe_to_message": "将来のセールとイベントについてお知らせします。ギフトや特別なオファーを手に入れよう！",
  "TaxFee": "税と料金",
  "Apply": "適用する",
  "Total_price": "合計金額",
  "Description": "詳細説明",
  "Payment method": "お支払い方法",
  "Back": "戻る",
  "Empty": "ショッピングバッグに商品が追加されていません。ショッピングを開始しましょう。",
  "After_sales": "アフターセールス",
  "Instruction3": "もちろん",
  "MyAccount_MyShippingDetails_Last": "姓",
  "MyAccount_MyShippingDetails_City": "市区町村",
  "payment_order_discount": "割引",
  "MyAccount_Order": "注文詳細",
  "ID_Name_Error": "あなたの身分証明書の名前を入力してください",
  "Kidswear": "子供服",
  "Share your look": "自分のルックをシェアしましょう",
  "Pay_Order": "注文を支払う",
  "Reset_Password": "パスワードをリセット",
  "MyAccount_MyProfile_label2_pass1": "現在のパスワード",
  "Create_Time_Desc": "日付降順",
  "Items": "アイテム",
  "Login_Register": "今すぐ登録する",
  "Back to homepage": "ホームページに戻る",
  "switch_CNY": "人民元に切り替える",
  "Successful placed order": "注文を承りました。お客様が注文状況を確認できる配送状況機能をご利用ください。注文確認メールは、注文の詳細とトラッキングリンクが含まれています。",
  "MyAccount_MyProfile_yinsi_link": "プライバシーポリシー",
  "Order_Date": "注文日付",
  "Allow order notifications": "注文通知を許可する",
  "MyAccount_MyProfile_Tab1": "プロフィール",
  "MyAccount_ShippingDetails_changeTitle": "住所を変更",
  "ID_Number": "身分証明書番号",
  "Order_after_sales_message": "注文詳細とアフターセールス注文",
  "MyAccount_MyProfile_title2": "アカウントへのアクセスパスワードを変更する場合は、以下の情報を入力してください。",
  "Customer service": "お客様サービス",
  "MyAccount_MyProfile_Update": "パスワードを更新する",
  "choose_language": "言語を選択する",
  "ORDER_REFUNDING": "払い戻し中",
  "MyAccount_MyProfile_title1": "詳細情報を編集すると、常に最新のアカウントになります。",
  "ORDER_WAIT_RATE": "評価待ち",
  "after_sales_refund_order": "注文返金",
  "Who we are": "私たちは誰ですか",
  "Women fashion": "女性ファッション",
  "Order_After_sales": "注文のアフターセールス",
  "concattus_button": "提出する",
  "Shipping_valid_required": "この項目は必須です",
  "Price": "価格",
  "ID_Type_Error": "ご利用の身分証明書のタイプを選択してください",
  "Order_Status": "注文ステータス",
  "Payment methods": "支払方法",
  "MyAccount_MyProfile_Tab2": "パスワードを変更する",
  "Show on page": "ページに表示する",
  "Edit": "編集する",
  "Change": "変える",
  "MyAccount_ShippingDetails_Update": "住所を更新する",
  "View": "見る",
  "Privacy": "プライバシー",
  "Enter_promo_code": "プロモーションコードを入力する",
  "Discount": "ディスカウント",
  "Delete": "削除する",
  "Wishlist": "ウィッシュリスト",
  "MyAccount_Order_History_Tabs3": "返品",
  "Go_To_Order_review": "評価に行く",
  "Update personal data": "個人データを更新する",
  "payment_agree_2": "条項と条件",
  "or fill the details below": "または以下の詳細を記入してください",
  "Contact details updated": "あなたの住所と連絡先を更新してください。",
  "Login_Create": "アカウントを作成する",
  "Payment": "支払い",
  "Billing": "請求書",
  "payment_insurance_tax": "保険税",
  "Size guide": "サイズガイド",
  "Login_forgotten_password": "パスワードを忘れた場合",
  "Login_no_account": "アカウントを持っていない場合",
  "Privacy_Policy": "プライバシーポリシー",
  "BootomCookieTitle": "Cookieの許可",
  "Use your personal data": "Brand nameでは、プライバシーに非常に注意を払っており、ユーザーの個人データを保護することに力を入れています。当社がどのようにあなたの個人データを処理し、保護するかについての詳細については、次を参照してください。",
  "Review my order": "私の注文を確認する",
  "BootomCookieLink": "さらに詳しく",
  "hide": "隠す",
  "MyAccount_ShippingDetails_message_title": "ワークプレイス、家庭住所など、希望のすべての出荷先を管理することにより、手動で出荷先を注文に入力する必要がなくなります。",
  "Purchase terms": "購入条件",
  "Billing_address": "請求書の住所",
  "Manage shipping addresses": "希望のすべての出荷先を管理することにより、手動で出荷先を注文に入力する必要がなくなります。（ワークプレイス、家庭住所など）",
  "login_logbtn": "アカウントにログインする",
  "choose_currency": "通貨を選択してください",
  "ORDER_REFUNDED": "返金済み",
  "After_sales_form": "アフターセールスフォームを記入する",
  "add_To_Wishlist": "ウィッシュリストに追加する",
  "search_results_inputnull2": "今すぐスタートして、あなたを手伝います。",
  "Total": "合計",
  "Subscribe_to_newsletter": "ニュースレターに登録する",
  "Shipping_valid_Phone": "有効な電話番号を入力してください",
  "concactus_label3": "タイトル",
  "Manage billing addresses": "希望のすべての請求書の住所を管理することにより、手動で請求書の住所を注文に入力する必要がなくなります。（ワークプレイス、家庭住所など）",
  "Search_results_title": "検索結果",
  "payment_order_payment": "注文支払い",
  "after_sales_Id": "アフターセールスID",
  "cart_title": "私のカート",
  "Order_Detail": "注文の詳細",
  "concactus_label2": "店舗へのリンク",
  "Shipping_valid_length_min": "このフィールドは{min}文字以上でなければなりません",
  "Product suggestions": "製品提案",
  "Return_home": "ホームに戻る",
  "Quality in the details": "細部にこだわった品質",
  "Continue_to_payment": "支払いを続ける",
  "Feedback": "あなたのフィードバックは私たちにとって非常に重要です。私たちが何を改善できるか教えてください。",
  "Go back to shop": "ショップに戻る",
  "Back_to_home": "ホームに戻る",
  "Review_Content": "レビューコンテンツ",
  "add_To_Cart": "カートに追加する",
  "Read_reviews": "レビューを読む",
  "Instruction1": "お手入れ方法",
  "Email_address": "メールアドレス",
  "Category_Item_List": "リストビューに切り替える",
  "Same as shipping address": "出荷先住所と同じ",
  "Category_Item_Grid": "グリッドビューに切り替える",
  "ID_Number_Error": "あなたの身分証明書番号を入力してください",
  "concactus_label4": "連絡メールアドレス",
  "Additional_info": "追加情報",
  "add_shipping": "新しい出荷先を追加する",
  "Product_description": "Karissa V-ネックTee は半合身設計で、さまざまな体型に適しています。カーブに密着して、一般的な「問題」エリアをカバーし、自信をもってフィットネスジムに出かけることができます。さらに、魅力的なレディースカクテルドレスとパーティードレスがあります。",
  "Login_create_account": "アカウントを作成する",
  "after_sales_Reason": "アフターセールスの理由",
  "MyAccount_MyProfile_label_Last": "姓",
  "MyAccount_MyProfile_label2_pass2": "新しいパスワード",
  "Save": "保存する",
  "CartSliderTextBtn": "あとで買うために保存する",
  "Color": "色",
  "Shipping_Tax": "送料税",
  "Subscribe_to_success": "あなたはすでに購読しています",
  "Enjoy your free account": "あなたの無料アカウント特典をお楽しみください！",
  "cart_empty_desc": "まだカートに商品が追加されていません。それを埋めるためにショッピングを始めましょう。",
  "MyAccount_ShippingDetails_message_title2": "あなたの住所や連絡先を最新に保つことが大切です。",
  "An_error_occured": "エラーが発生しました",
  "Country": "国",
  "payment_insurance_fee": "保険料",
  "Home": "ホーム",
  "Contact_us": "お問い合わせ",
  "Your current email address is": "您当前的電子メールアドレスは",
  "You currently have no orders": "現在、注文はありません",
  "Login_input_password": "パスワード",
  "Promo_code": "プロモーションコード",
  "order_count": "注文数",
  "email_geshi_error": "有効な電子メールアドレスを入力してください。",
  "your_email": "あなたの電子メール",
  "email": "電子メール",
  "you_have_subscribed": "あなたはすでに購読しています",
  "cancel_Subscribe": "購読をキャンセルする",
  "save_and_pay": "保存并支払う",
  "hasInsurance": "保険を購入するかどうか",
  "pleasePayType": "支払い方法を選択してください",
  "zhuanfa_toBePay": "友達に支払ってもらうために転送する",
  "linkCopied": "リンクがコピーされました、友達と共有するために貼り付けてください",
  "Links": "リンク",
  "article_category": "記事のカテゴリー",
  "wechat_code_login_message": "微信のQRコードをスキャンしてログインしてください",
  "wechat_code_login": "微信でQRコードログイン",
  "Api_Update_success": "更新に成功しました",
  "Please_Use_WeChat_login": "微信でログインしてください",
  "mobile_geshi_error": "有効な携帯電話番号を入力してください",
  "Login_input_email_required": "電子メールを入力してください",
  "article_null": "記事がありません",
  "Login_with_microsoft": "マイクロソフトログイン",
  "article_null_des": "他のカテゴリの記事を閲覧できます",
  "register_email": "メールアドレスで登録する",
  "Login_tab_email": "メールアドレスでログイン",
  "code.time": "{time}秒後に再試行してください",
  "Login_with_wechat": "WeChatでログインする",
  "cat_items_null_des": "他のカテゴリの商品を閲覧できます",
  "Login_with_facebook": "Facebookでログインする",
  "Login_input_code": "確認コード",
  "Login_input_mobile_required": "携帯番号を入力してください",
  "Login_input_mobile": "あなたの携帯番号",
  "cat_items_null": "このカテゴリには商品がありません",
  "Login_with_twitter": "Twitterでログインする",
  "mobile_code": "確認コード",
  "register_mobile": "電話番号で登録する",
  "Login_tab_mobile": "電話番号でログイン",
  "Login_with_google": "Googleでログインする",
  "inPayOrderAll": "支払い待ちリスト",
  "payPrice": "支払い金額",
  "shipping_add_success": "配送先が作成されました",
  "match_goods": "売れ筋商品",
  "pay_code_refresh": "支払いコードの更新",
  "pay_code_shixiao": "支払いQRコードは期限切れです",
  "concactus_title": "お問い合わせ",
  "Search_items": "検索",
  "WebAutoLang": "現在のブラウザのお勧め言語は、{lang} です。この言語に切り替えますか？",
  "Services_Name": "サービス名",
  "Services_Price": "サービス料金",
  "SwichLang": "言語切り替え",
  "Services_Description": "サービスの説明",
  "goodinfo_null": "商品がありません",
  "goodinfo_null_des": "他のカテゴリの商品を閲覧できます",
  "billing_and_shipping": "アカウントと配送先住所が同じです",
  "select_coupon": "クーポンを選択",
  "select_gift": "ギフトを選択",
  "currentUseCode": "既に使用されたクーポン",
  "shipping_refresh": "リストを更新する",
  "Shipping_details": "受け取り住所",
  "MyAccount_Newsletter": "購読",
  "MyAccount_Profile": "プロフィール",
  "MyAccount_Wishlist": "ウィッシュリスト",
  "MyAccount_History": "注文履歴",
  "bind_microsoft": "マイクロソフトをバインドする",
  "bind_twitter": "Twitterをバインドする",
  "bind_facebook": "Facebookをバインドする",
  "bind_wechat_code": "WeChat QRコード",
  "bind_wechat": "WeChatをバインドする",
  "bind_google": "Googleをバインドする",
  "Wishlist_Empty": "心の希望リストがありません",
  "discount_post_fee": "送料割引",
  "ORDER_PART_PAID": "一部支払い",
  "claimCouponeSuccess": "{name}を受け取りました",
  "discount_kou": "{discount}折",
  "cartPreviewSafety_messageinfo": "安全、迅速な配達があなたの住所に届けられます",
  "Order_No": "注文番号",
  "MyAccount_MyShippingDetails_HouseNumber": "門番号",
  "Shipping_title": "配達先住所",
  "Offline_payment": "オフライン支払い",
  "shopName": "ショップ名",
  "Social": "ソーシャル",
  "Sort_by": "ソート方式",
  "Departments": "法律声明",
  "cartPreviewSafety": "安全配送",
  "Personal details": "個人情報",
  "Password": "パスワード",
  "wishlist_empty_title": "あなたのウィッシュリストには何もありません",
  "Shipping": "出荷",
  "Repeat_Password": "パスワードの再入力",
  "cart_price": "小計",
  "Customer Reviews": "お客様のご感想",
  "Continue to shipping": "配送に進む",
  "payment_make_order": "注文する",
  "save_order_review": "レビューを保存する",
  "Save_Password": "パスワードを保存する",
  "cart_empty_title": "カートに商品がありません",
  "TopBar_help": "ヘルプ/よくあるご質問",
  "colseCookie": "わかりました",
  "Password_Changed": "パスワードが正常に変更されました。今すぐホームページに戻ってログインしてください。",
  "Forgot Password Modal Email": "ログインに使用したメールアドレス：",
  "MyAccount_Personal": "個人情報",
  "cartPreviewShipping": "便利な出荷",
  "ORDER_AFTER_SALE": "售後中",
  "Page_not_found": "ページが見つかりません",
  "Find out more": "もっと詳しく知る",
  "Log into your account": "アカウントにログインする",
  "Details_and_status_orders": "オンラインストアで注文の詳細情報と状態を確認してください。注文をキャンセルしたり、返品の申請をしたりすることもできます。",
  "MyAccount_MyShippingDetails_Street": "住所",
  "Order_to_be_paid_message": "支払い待ち",
  "Guarantee": "保証",
  "Sections that interest you": "あなたが興味を持つセクション",
  "payment_post_tax": "送料および税金",
  "ORDER_PAID": "支払い済み",
  "concactus_label5": "呼び方",
  "Item": "アイテム",
  "Go_back": "戻る",
  "more": "詳しく見る",
  "MyAccount": "マイアカウント",
  "payment_agree_1": "同意します",
  "total_items": "総アイテム数",
  "shopping_go": "配送先住所を管理する",
  "ID_Type": "身分証タイプ",
  "after_sales_status": "售後ステータス",
  "After_sales_apply": "售後申し込み",
  "Login": "ログイン",
  "Quantity": "数量",
  "payment_post_fee": "送料",
  "MyAccount_Log_out": "ログアウト",
  "Subtotal": "小計",
  "forgotPasswordConfirmation": "ありがとうございます。{0}のメールアドレスでアカウントを登録した場合は、メール受信トレイにパスワードリセットのリンクが含まれたメッセージが届きます。",
  "MyAccount_Order_History_Tabs1": "マイオーダー",
  "concactus_img": "画像をアップロード",
  "Done": "完了",
  "Info after order": "前に定義したメールとパスワードを使用してアカウントにログインできます。アカウントでは、プロフィールを編集したり、注文履歴を確認したり、購読ニュースレターを編集したりできます。",
  "MyAccoubnt_Set_newsletter": "ニュースレターを設定してください。お選びいただいた製品やトレンド情報を毎週お送りします。",
  "Shipping_method": "送料",
  "after_sales_refund": "返金金額",
  "After_sales_save": "售後情報を保存する",
  "go_order_history": "注文履歴を確認する",
  "contactus_message_placeholder": "コメントや質問を書いてください",
  "Login_Forgot_Password": "パスワードを忘れた場合、リセットできます。",
  "show_more": "もっと見る",
  "MyAccount_MyProfile_label_email": "メールアドレス",
  "MyAccount_MyProfile_label2_pass3": "パスワードを再度入力",
  "Products": "製品",
  "Review": "レビュー",
  "MyAccount_MyProfile_title3": "現在のメールアドレスは",
  "Category_found_Products": "検出された製品",
  "Match": "マッチング",
  "Read_all_reviews": "すべてのレビューを読む",
  "See_all": "すべて見る",
  "Commercial information": " {0} からのパーソナライズされた商業情報を受け取ることに同意します。",
  "Change password your account": "アカウントのアクセスパスワードを変更する場合は、以下の情報を入力してください。",
  "ID_Name": "身分証明書の名前",
  "All": "すべて",
  "Instruction2": "メンテナンスに関する情報だけを必要としていますか？",
  "MyAccount_ShippingDetails_Add": "新しい住所を追加する",
  "MyAccount_MyShippingDetails_Zip": "郵便番号",
  "go_pay_order": "支払いに進む",
  "Thank_You_Inbox": "メッセージが受信トレイに届かない場合は、登録に使用した別のメールアドレスをお試しください。",
  "Subscribe": "定期購読する",
  "confirm_subscription": "私は購読を確認します",
  "Login_input_Remember": "ログイン情報を保存する",
  "Add to compare": "比較に追加",
  "Brand": "ブランド",
  "Start_shopping": "ショッピングを始める",
  "Select shipping method": "配送方法を選択してください",
  "address CN": "住所が中国の場合、現在の通貨は中国元である必要があります",
  "MyAccount_MyShippingDetails_State": "都道府県",
  "Page_not_found_message2": "戻るか再試行してください",
  "Go_to_checkout": "チェックアウトに進む",
  "See all results": "すべての結果を見る",
  "search_results_inputnull": "何も検索していません。",
  "subscribeToNewsletterModalContent": "ニュースレターに登録すると、VSFから特別なオファーや情報を受け取ることができます。いつでも、任意の第三者に対して、Eメールアドレスは販売または配布されません。詳細については、{0}をご覧ください。",
  "Download all": "すべてダウンロード",
  "Amount": "金額",
  "ORDER_WAIT_PAYMENT": "未払い",
  "Basket": "ショッピングカート",
  "MyAccount_MyProfile_reqeatPassErrMsg": "新しいパスワードが一致しません",
  "OrderSku": "商品仕様",
  "order_shopping_firstname": "名前",
  "Login_input_last": "名前",
  "MyAccount_MyShippingDetails_First": "名前",
  "Cookies Policy": "クッキー政策",
  "Clear all": "すべてクリア",
  "Order_logisticsNo": "物流オーダー番号",
  "Order_logisticsName": "物流会社",
  "ItemPrice": "商品の金額",
  "notYetUseCode": "割引コードが使用されていません",
  "guest_Login": "観光客登録",
  "claimCoupone": "受け取る",
  "SERVICE": "サービス",
  "onlineContact": "オンライン連絡先",
  "confirm": "確認",
  "closeOrder": "注文キャンセル",
  "closeOrderContext": "本当に注文をキャンセルしますか？",
  "Message_Read": "既読",
  "close.order.success": "注文はキャンセルされました",
  "shippingAddress": "住所",
  "Message": "メッセージ",
  "Message_Empty_Title": "あなたのメッセージは空です",
  "MyAccount_Message": "メッセージ",
  "Message_Empty": "メッセージはありません",
  "payment_order_note": "注文備考",
  "go_to_see_prepid": "未払いの注文を確認するにはここをクリックしてください",
  "operate": "操作",
  "removeCartItemContext": "您确定要移除{title}吗？",
  "shippingItemQty": "配送数量",
  "removeCartItem": "移除商品",
  "shippingInfo": "配送情報",
  "Distributor_success": "既に成功した販売代理店",
  "Distributor_apply": "販売代理店になる申請",
  "Distributor_Details": "販売代理店",
  "DistributorSataus": "状況",
  "Distributor_Details_Empty": "一時的に販売代理店がいない",
  "distributor.status.4": "無効",
  "distributor.status.1": "未審査",
  "Distributor_copy_url": "販売リンクをコピーする",
  "Order_Time": "注文時間",
  "Order_User": "注文者",
  "Distributor_copy_success": "コピーに成功しました",
  "distributor.status.3": "精算済み",
  "MyAccount_Distributor": "販売代理店",
  "MyAccoubnt_Set_Distributor": "販売代理店になる申請",
  "distributor.status.2": "未精算",
  "DistributorAmount": "手数料",
  "Distributor_shenheshibai": "分销業者の審査は未承認です。",
  "Distributor_shenhezhong": "分销業者の審査中です。",
  "Distributor_Order_Empty": "現在、分销注文はありません。",
  "NE": "ニジェール",
  "DJ": "ジブチ",
  "KP": "朝鮮",
  "US": "アメリカ合衆国",
  "LC": "セントルシア",
  "NL": "オランダ",
  "CD": "コンゴ民主共和国",
  "IS": "アイスランド",
  "MA": "モロッコ",
  "GH": "ガーナ",
  "KR": "韓国",
  "MK": "マケドニア旧ユーゴスラビア共和国",
  "HT": "ハイチ",
  "PF": "フランス領ポリネシア",
  "GA": "ガボン",
  "TD": "チャド",
  "LB": "レバノン",
  "CG": "コンゴ",
  "KG": "キルギス",
  "TA": "トリスタン・ダ・クーニャ",
  "KW": "クウェート",
  "TL": "東ティモール",
  "IN": "インド",
  "NO": "ノルウェー",
  "NG": "ナイジェリア",
  "AQ": "南極",
  "LY": "リビア",
  "NI": "ニカラグア",
  "TT": "トリニダード・トバゴ",
  "HM": "ハード島とマクドナルド諸島",
  "PY": "パラグアイ",
  "BA": "ボスニア・ヘルツェゴビナ",
  "JP": "日本",
  "MD": "モルドバ",
  "MT": "マルタ",
  "RE": "レユニオン島",
  "UG": "ウガンダ",
  "SB": "ソロモン諸島",
  "SL": "シエラレオネ",
  "CV": "カボベルデ",
  "SD": "スーダン",
  "FO": "フェロー諸島",
  "ZA": "南アフリカ",
  "TR": "トルコ",
  "FK": "フォークランド諸島",
  "PA": "パナマ",
  "GF": "フランス領ギアナ",
  "TJ": "タジキスタン",
  "NC": "ニューカレドニア",
  "PM": "サンピエール島・ミクロン島",
  "NU": "ニウエ",
  "AO": "アンゴラ",
  "VN": "ベトナム",
  "GN": "ギニア",
  "MW": "マラウイ",
  "BY": "ベラルーシ",
  "IM": "マン島",
  "BI": "ブルンジ",
  "BS": "バハマ",
  "CK": "クック諸島",
  "MH": "マーシャル諸島",
  "CR": "コスタリカ",
  "HK": "香港",
  "AD": "アンドラ",
  "BN": "ブルネイ",
  "SN": "セネガル",
  "AE": "アラブ首長国連邦",
  "GI": "ジブラルタル",
  "CA": "カナダ",
  "AX": "オーランド諸島",
  "UY": "ウルグアイ",
  "WF": "ワリス・フツナ",
  "GM": "ガンビア",
  "SO": "ソマリア",
  "RU": "ロシア",
  "PL": "ポーランド",
  "FM": "ミクロネシア連邦",
  "ET": "エチオピア",
  "EE": "エストニア",
  "SK": "スロバキア",
  "AS": "アメリカ領サモア",
  "ZM": "ザンビア",
  "AL": "アルバニア",
  "AT": "オーストリア",
  "VA": "バチカン市国",
  "TW": "中国台湾",
  "BD": "バングラデシュ",
  "AR": "アルゼンチン",
  "EH": "西サハラ",
  "MO": "中国マカオ特別行政区",
  "MV": "モルディブ",
  "GU": "グアム",
  "AW": "アルバ",
  "AI": "アンギラ",
  "CL": "チリ",
  "IL": "イスラエル",
  "GD": "グレナダ",
  "WS": "サモア",
  "SE": "スウェーデン",
  "GP": "グアドループ",
  "YE": "イエメン",
  "GT": "グアテマラ",
  "BG": "ブルガリア",
  "SJ": "スバールバル諸島およびヤンマイエン島",
  "CO": "コロンビア",
  "LS": "レソト",
  "LV": "ラトビア",
  "UM": "米国外諸島",
  "MX": "メキシコ",
  "DO": "ドミニカ共和国",
  "PE": "ペルー",
  "HN": "ホンジュラス",
  "TC": "タークス・カイコス諸島",
  "VI": "アメリカ領ヴァージン諸島",
  "FJ": "フィジー",
  "MP": "北マリアナ諸島",
  "AC": "アセンション島",
  "NA": "ナミビア",
  "SZ": "スワジランド",
  "RW": "ルワンダ",
  "BH": "バーレーン",
  "KN": "セントクリストファー・ネイビス",
  "TN": "チュニジア",
  "AF": "アフガニスタン",
  "VG": "英領ヴァージン諸島",
  "KE": "ケニア",
  "PK": "パキスタン",
  "GL": "グリーンランド",
  "SY": "シリア",
  "CU": "キューバ",
  "RS": "セルビア",
  "BF": "ブルキナファソ",
  "BM": "バミューダ諸島",
  "BZ": "ベリーズ",
  "SV": "エルサルバドル",
  "CN": "中国",
  "MF": "セントマーチン",
  "NF": "ノーフォーク島",
  "MZ": "モザンビーク",
  "LU": "ルクセンブルク",
  "TO": "トンガ",
  "GR": "ギリシャ",
  "SI": "スロベニア",
  "PW": "パラオ",
  "TZ": "タンザニア",
  "IR": "イラン",
  "GG": "ガーンジー",
  "SM": "サンマリノ",
  "TF": "仏領南方・南極地域",
  "PS": "パレスチナ",
  "SC": "セーシェル",
  "BT": "ブータン",
  "JM": "ジャマイカ",
  "BR": "ブラジル",
  "CH": "スイス",
  "SH": "セントヘレナ",
  "HU": "ハンガリー",
  "TM": "トルクメニスタン",
  "LT": "リトアニア",
  "MC": "モナコ",
  "LI": "リヒテンシュタイン",
  "LR": "リベリア",
  "GE": "ジョージア",
  "SA": "サウジアラビア",
  "GB": "イギリス",
  "VE": "ベネズエラ",
  "MU": "モーリシャス",
  "HR": "クロアチア",
  "SR": "スリナム",
  "CM": "カメルーン",
  "IQ": "イラク",
  "BO": "ボリビア",
  "MN": "モンゴル",
  "DZ": "アルジェリア",
  "TK": "トケラウ",
  "MG": "マダガスカル",
  "YT": "マヨット島",
  "CC": "ココス（キーリング）諸島",
  "LA": "ラオス人民民主共和国",
  "PT": "ポルトガル",
  "QA": "カタール",
  "AN": "オランダ領アンティル",
  "PN": "ピトケアン諸島",
  "ES": "スペイン",
  "VC": "セントビンセントおよびグレナディーン諸島",
  "AU": "オーストラリア",
  "CX": "クリスマス島",
  "KM": "コモロ",
  "MR": "モーリタニア",
  "FR": "フランス",
  "SG": "シンガポール",
  "BV": "ブーベ島",
  "PH": "フィリピン",
  "CY": "キプロス",
  "TV": "ツバル",
  "CF": "中央アフリカ共和国",
  "EC": "エクアドル",
  "GW": "ギニアビサウ",
  "IE": "アイルランド",
  "LK": "スリランカ",
  "ER": "エリトリア",
  "GQ": "赤道ギニア",
  "NP": "ネパール",
  "BE": "ベルギー",
  "GY": "ガイアナ",
  "DK": "デンマーク",
  "MQ": "マルティニーク",
  "UZ": "ウズベキスタン",
  "CI": "コートジボワール",
  "ID": "インドネシア",
  "BJ": "ベニン",
  "ST": "サントメ・プリンシペ",
  "KH": "カンボジア",
  "KZ": "カザフスタン",
  "MS": "モントセラト",
  "TH": "タイ",
  "FI": "フィンランド",
  "ML": "マリ",
  "AM": "アルメニア",
  "IT": "イタリア",
  "NR": "ナウル",
  "PG": "パプアニューギニア",
  "ZW": "ジンバブエ",
  "JO": "ヨルダン",
  "OM": "オマーン",
  "ME": "モンテネグロ",
  "JE": "ジャージー島",
  "NZ": "ニュージーランド",
  "VU": "バヌアツ",
  "DE": "ドイツ",
  "CZ": "チェコ共和国",
  "DM": "ドミニカ国",
  "KY": "ケイマン諸島",
  "BW": "ボツワナ",
  "RO": "ルーマニア",
  "PR": "プエルトリコ",
  "AZ": "アゼルバイジャン",
  "IO": "英領インド洋地域",
  "UA": "ウクライナ",
  "TG": "トーゴ",
  "MY": "マレーシア",
  "AG": "アンティグア・バーブーダ",
  "EG": "エジプト",
  "GS": "南ジョージア島・南サンドイッチ諸島",
  "MM": "ミャンマー (ビルマ)",
  "BB": "バルバドス島",
  "KI": "キリバス",
  "All_Country": "すべて",
  "post_state_country": "配送料： {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "配送先",
  "ShippingFee": "配送料金",
  "reviewOutOf": "{rating} スター、共 5 スター",
  "product.pifa.label": "買う {startnum} - {endnum}個",
  "product.pifa.type.1": "割引",
  "Write_a_review": "レビューを書く",
  "BasedOnTotalReviews": "{total}件のレビューに基づく",
  "product.wholesale": "卸売価格",
  "reviewMostRecent": "最新のレビュー",
  "product.pifa.type.2": "単価",
  "product.num.danwei": "個",
  "good.shoppingDateLabel": "発送日",
  "good.shippingPeriod": "日以内に発送",
  "emailError": "メールアドレスの形式が正しくありません",
  "addressNote": "注釈",
  "Concactus": "連絡",
  "addressMessage": "あなたの住所が正しいことを確認してください。支払い後に住所を変更することはできません。",
  "showOrderSummary": "注文概要",
  "payment_method": "支払方法",
  "emailNotNullError": "電子メールを入力してください",
  "orderCreateLoading": "注文を作成中...",
  "emailNote": "連絡",
  "emailMessage": "あなたの電子メールアドレスが正しいことを確認してください。注文確認メールをお送りします。",
  "payment_method_message": "すべての取引は安全で暗号化されています。",
  "go_buy_goods": "買い物を続ける",
  "tap_cancel_order": "ここをクリックして注文をキャンセルする",
  "order_review": "注文評価",
  "Add_new_address": "新しい住所を追加する",
  "promo_code_type_3": "購入金額達成クーポン",
  "IdCardNotNull": "本名情報を入力してください",
  "UploadVideo": "動画をアップロードする",
  "video": "ビデオ",
  "UploadImage": "画像をアップロードする",
  "uploadImageing": "アップロード中...",
  "BillingInfoNotNull": "請求情報が不完全です",
  "promo_code_type_2": "商品券",
  "UploadError": "アップロードに失敗しました",
  "promo_code_type_4": "送料割引クーポン",
  "image": "画像",
  "paymentMethodNotNull": "お支払方法を選択してください",
  "promo_code_type_1": "割引クーポン",
  "shippingInfoNotNull": "配送情報が不完全です",
  "reviewDetail": "評価の詳細",
  "DeliveryCountry": "配送区域",
  "prompt_error": "エラーを表示する",
  "save_review_success": "レビューが成功しました",
  "ORDER_COMPLETED": "完了済み",
  "crate_after_sales": "アフターセールスを作成する",
  "Thank_You_Order": "ご注文ありがとうございます！",
  "Thank_You_Order_sub": "ご注文を承りました。弊社で受注処理を開始し、注文に関するメールをお送りさせていただきます。",
  "BootomCookieContext": "このサイトは、正常な動作をサポートし、サイトとのやり取りの方法を理解するのに役立つクッキーを使用しています。これらのクッキーを使用して、より良い個人化されたユーザーエクスペリエンスを提供します。このサイトを引き続きご利用いただく場合、クッキーの使用に同意したものとみなされます。",
  "order_reivice_message": "商品を受け取りましたか？",
  "order_reivice_btn": "受け取り確認",
  "order_reivice_label": "受取り注文",
  "order_reivice_success": "受け取り成功",
  "collpase_show": "詳しく見る",
  "collpase_hide": "折りたたむ",
  "CouponCode": "割引クーポンコード",
  "wechatPayScannerCode": "ウィーチャットで支払うにはスキャナーコードを使用してください",
  "processing": "アフターサービス処理中",
  "finished": "アフターサービス完了",
  "login.showPrice": "ログイン後に価格を確認する",
  "After_Sales_Unknown": "アフターサービスの状態が不明",
  "order_payment_list_null": "支払い待ちの注文はありません",
  "Cancel": "キャンセル",
  "thankyou_concat": "ご不明な点がございましたら、お気軽にお問い合わせください"
}